import React from 'react';

import { StyledMp4Video } from './styles';

const Mp4Video = ({ src }) => {
  return (
    <StyledMp4Video muted={true} playsInline={true} autoPlay={true} loop={true}>
      <source src={src} />
    </StyledMp4Video>
  );
};

export default Mp4Video;
